import React from 'react'
import styles from './Clients.module.css'
import c1 from '../Images/c1.jpeg'
import c2 from '../Images/c2.jpeg'
import c3 from '../Images/c3.jpeg'
import c4 from '../Images/c4.jpeg'
import c5 from '../Images/c5.jpeg'
import c6 from '../Images/c6.jpeg'
import c7 from '../Images/c7.jpeg'
import c8 from '../Images/c8.jpeg'
import c9 from '../Images/c9.jpeg'
import c10 from '../Images/c10.jpeg'
import c11 from '../Images/c11.jpeg'
import c12 from '../Images/c12.jpeg'
import c13 from '../Images/c13.jpeg'
import c14 from '../Images/c14.jpeg'
import c15 from '../Images/c15.jpeg'
import c16 from '../Images/c16.jpeg'
import c17 from '../Images/c17.jpeg'
import c18 from '../Images/c18.jpeg'
import c19 from '../Images/c19.jpeg'
import c20 from '../Images/c20.jpeg'
import c21 from '../Images/c21.jpeg'




export default function Clients() {



  return (
<>



 <div className="container-fluid mt-5">
  <div className="row text-center">
   
    <h2 className='text-center fs-2 fw-bolder position-relative mainColor'>
           Our Clients
        <div class={`${styles.middleTric} position-absolute top-0 start-50 translate-middle `}> c </div>
        <div className="shortline mt-2"></div>
    <div className="longline"></div>
    <div className="shortline mb-2"></div>
      </h2>
      {/* <div>
      <img src={clientsImg} alt="achegy" className='img-fluid'/>
      </div>
     <div className='text-center'>
     <img src={clientsImg2} alt="achegy" className='img-fluid text-center'/>
     </div> */}
     <div className="col-md-2">
       <img src={c1} alt="achegy" className={`${styles.ClientLogos}  text-center`} />
     </div>
      <div className="col-md-2">
       <img src={c2} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c3} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c4} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c5} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c6} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c7} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c8} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c9} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      {/* <div className="col-md-2">
       <img src={c10} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div> */}
      <div className="col-md-2">
       <img src={c11} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c12} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c13} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c14} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c15} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c16} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c17} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c18} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c19} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c20} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      <div className="col-md-2">
       <img src={c21} alt="achegy" className={`${styles.ClientLogos}  text-center`}/>
     </div>
      
     
   
  </div>
 </div> 
    </>    
   
  )
}

